module.exports = __webpack_public_path__ + "img/review-6.15e4f21e.png";